import { module } from 'modujs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init(){
        // this.isOpen = false
    }

    toggle() {
        if(html.classList.contains('has-history-open')) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        // this.isOpen = true

        this.call('open', 'History')
    }

    close() {
        // this.isOpen = false

        this.call('close', 'History')
    }
}
